import { useState } from "react";
import Select from 'react-select';

const TableHead = ({columns, sortmobile, selectedOption, setSelectedOption, sort}) => {

    return (
        <div className="table__head">
            <div>Сортировка:</div>
            <div>
                <Select
                    className="select"
                    classNamePrefix="select"
                    placeholder={'Сортировать'}                            
                    isSearchable={false}    
                    getOptionLabel={(opt) => {
                        let direction = sort && opt.value == sort.key ? sort.direction : '';
                        return <label className={'sort ' + direction}>{opt.label}</label>;
                      }}
                    components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                    }} 
                    defaultValue={selectedOption}
                    onChange={(option) => setSelectedOption(option.value)}
                    options={sortmobile}
                />
            </div>                        
        </div>
    )
}

export default TableHead